import React, { useContext, useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Context } from "../helpers/Context";
import { getCurrentDomain } from "../helpers/Lookup";
import { ConfirmDialogStyles } from '../helpers/Global';
import { confirm } from "react-confirm-box";

const OrderHistoryItem = ({ items, onReload }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showWorking, setShowWorking] = useState(false);

  const allExtractedData = [];
  const { products, getProducts, oldItems, getOldCartItems, processPayment, CancelCart } = useContext(Context);

  const toggle = () => {
    getOldCartItems(items.id, () => {
      setIsOpen(!isOpen);
    });
  };

  const toggleWorking = () => {
    setShowWorking(!showWorking);
  };

  const getImage = (productId) => {
    const selectedProduct = products.find(item => item.id === productId);
    return selectedProduct && selectedProduct.images ? selectedProduct.images.includes("DynamicData") ? JSON.parse(selectedProduct.images)[0].includes("\\") && JSON.parse(selectedProduct.images)[0].includes("[") ? getCurrentDomain() + JSON.parse(JSON.parse(selectedProduct.images))[0].replace(/\\/g, "/") : getCurrentDomain() + JSON.parse(selectedProduct.images)[0].replace(/\\/g, "/") : selectedProduct.images.split(", ")[0] : "/assets/imgs/Razer_wordmark.png";
  };

  const handleRedoPayment = async (cart) => {
    if (await confirm("Are you sure you want to redo this payment?", ConfirmDialogStyles)) {
      setShowWorking(true);
      await processPayment(cart.cartId, cart.addressId, cart.instructions);
    }
  }

  const handleCancelCart = async (cart) => {
    if (await confirm("Are you sure you want to cancel this order?", ConfirmDialogStyles)) {
      await CancelCart(cart.cartId);
      if (onReload)
        onReload();
      //setShowWorking(true);
      //await processPayment(cart.cartId, cart.addressId, cart.instructions);
    }
  }

  useEffect(() => {
    getProducts();
    //getOldCartItems(items.id);
  }, []);
  
  return (
    <>
      <div className="order-item">
        <div className="col-md-1"><strong>Order Number:  &nbsp;</strong><small>{"TC" + items.orderId.toString().padStart(4, '0')}</small></div>
        <div className="col-md-2"><strong>Order Date:  &nbsp;</strong><small>{new Date(items.dateSubmitted).toDateString()}</small></div>
        <div className="col-md-2"><strong>Paid Date:  &nbsp;</strong><small>{items.dateComplete ? new Date(items.dateComplete).toDateString() : ""}</small></div>
        <div className="col-md-2"><strong>Status:  &nbsp;</strong><small>{items.statusMessage}</small></div>
        <div className="col-md-2"><strong>Payment Method:  &nbsp;</strong><small>{items.paymentMethodTitle}</small></div>
        <div className="col-md-1"><strong>Items:  &nbsp;</strong><small>{items.numItems}</small></div>
        <div className="col-md"><strong>Total:  &nbsp;</strong><small>{items.amount.toCurrencyString()}</small></div>
        {items.status === 1 && (
          <>
            <span onClick={() => handleCancelCart(items)}>
              <i className="fa-solid fa-ban" title="Cancel Order"></i>
            </span>
            &nbsp;
            <span onClick={() => handleRedoPayment(items)}>
              <i className="fa-light fa-money-check-pen" title="Retry Payment"></i>
            </span>
            &nbsp;
          </>
        )}

        <span onClick={toggle}><i className="fa-solid fa-eye"></i></span>
      </div>
      <Modal isOpen={isOpen} toggle={toggle} centered>
        <ModalHeader toggle={toggle} className="bg-dark text-light">Product Information</ModalHeader>
        <ModalBody className="bg-dark text-light">
          {oldItems && oldItems.map((data, index) => (
            <div className="history" key={index}>
              <div className="image-container mb-3">
                <img src={getImage(data.productId)} alt={data.title} />
              </div>
              <div><span className="text-muted">Product Name:</span> <small>{data.title}</small></div>
              <div><span className="text-muted">Product ID:</span> {data.productId}</div>
              <div><span className="text-muted">SKU:</span> {data.sku}</div>
              <div><span className="text-muted">Quantity:</span> <small>{data.qty}</small></div>
              <div><span className="text-muted">Sub Total:</span> <small>{data.priceCharged.toCurrencyString()}</small></div>
              <div><span className="text-muted">Total:</span> <small>{data.totalCharged.toCurrencyString()}</small></div>
              <hr />
            </div>
          ))}
        </ModalBody>
      </Modal>

      <Modal isOpen={showWorking} toggle={toggleWorking} centered>

        <ModalBody>
          <div className="text-center">
            <i className='fas fa-spinner fa-spin fa-4x'></i>
            <h5>Please wait, redirecting to the payment portal</h5>
          </div>
        </ModalBody>
      </Modal>

    </>
  );
};

export default OrderHistoryItem;